<template>
    <div class="l-live-body">
        <img class="l-main-right" @click="handleShowRule()" src="./images/rule.png" alt="">
        <div class="l-main-back">
            <img class="l-back-img" src="./../images/back.png" alt="" />
            <div class="l-back-button" @click="handleGoBack()"></div>
        </div>
        <div class="l-live-main">
            <div class="no-rate-tpis" v-if="(parseFloat(listData.singeRate) < 50)">出勤率小于50%，无LILY币奖励</div>
            <div class="l-live-title">
                直播指导表现
            </div>
            <div class="l-live-header">
                <div class="header-time">
                    <img src="./images/title-icon2.png" alt="">
                    <span>{{ listData.guidanceDate }}</span>
                </div>
                <div class="header-name">
                    <img src="./images/title-icon1.png" alt="">
                    <span>{{ listData.className }}</span>
                </div>
                <div class="header-rate">
                    <img src="./images/title-icon3.png" alt="">
                    <span>战队出勤率</span>
                    <span :class="{ 'no-rate': parseFloat(listData.singeRate) < 50 }">
                        {{ listData.singeRate }}
                    </span>
                </div>
            </div>
            <!-- 补充故事录音 -->
            <div v-if="listData.studyStage" class="story-record-header">
                <span class="record-header-label">段位</span>
                <span class="record-header-label">故事名称</span>
                <span class="record-header-label" style="width: 3.4rem">录音</span>
            </div>
            <div v-if="listData.studyStage" class="story-record">
                <span class="record-label">{{ listData.studyStage }}</span>
                <span class="record-label">{{ listData.storyName }}</span>
                <audio class="record-audio"
                    style="width: 3.4rem"
                    controls controlsList="nodownload"
                    :src="listData.storyUrl">
                    您的浏览器不支持 audio 元素。
                </audio>
            </div>
            <div class="l-live-list-title">
                <div class="level">排名</div>
                <div class="title-border"></div>
                <div class="name">队员</div>
                <div class="title-border"></div>
                <div class="status">是否出勤</div>
                <div class="title-border"></div>
                <div class="add">直播指导加分</div>
                <div class="title-border"></div>
                <div class="punishment">直播指导减分</div>
                <div class="title-border"></div>
                <div class="award">LILY币奖励</div>
            </div>
            <div class="l-live-content">
                <div class="l-live-list">
                    <ul>
                        <li v-for="(item, index) in listData.rankList" :key="index" class="l-live-list-item"
                            :class="{ 'l-live-list-user': item.current === 1 }">
                            <div class="l-live-list-item-box">
                                <div class="level">{{ item.num }}</div>
                                <div class="name">{{ item.userName }}</div>
                                <div class="status">
                                    <div class="status-icon attendance">{{ item.live }}</div>
                                </div>
                                <div class="add">
                                    <div class="item-score wen" v-for="(wenValue, wenIndex) in item.rewardWen "
                                        :key="wenIndex + 'wen'">
                                        <div class="score-top">+{{ wenValue }}</div>
                                        <div class="score-bottom"></div>
                                    </div>
                                    <div class="item-score wu" v-for="(wuValue, wuIndex) in item.rewardWu "
                                        :key="wuIndex + 'wu'">
                                        <div class="score-top">+{{ wuValue }}</div>
                                        <div class="score-bottom"></div>
                                    </div>
                                </div>
                                <div class="punishment">
                                    <div class="item-score subtract"
                                        v-for="(punishmentValue, punishmentIndex) in item.punishment"
                                        :key="punishmentIndex + 'punishment'">
                                        <div class="score-top">{{ punishmentValue }}</div>
                                        <div class="score-bottom"></div>
                                    </div>
                                </div>
                                <div v-if="((parseFloat(listData.singeRate) >= 50) && item.coin)" class="award"> <img
                                        src="./images/l-coin.png" alt="">
                                    <span>+{{ item.coin }}</span>
                                </div>
                                <div v-else class="award"></div>
                            </div>
                            <img v-if="item.current === 1" class="l-live-list-one" src="./images/one.png" alt="">
                            <div v-if="item.winnerCoin" class="l-live-list-winner">
                                <div class="winner-icon"><img src="./images/winner.png" alt=""></div>
                                <div class="winner-coin"><img src="./images/l-coin.png" alt="">
                                    <span>+{{ item.winnerCoin }}</span>
                                </div>
                            </div>

                        </li>
                    </ul>
                </div>
                <div class="l-list-title">未出勤队员</div>
                <div class="l-live-list">
                    <ul>
                        <li v-for="(item, index) in listData.absenceList" :key="index" class="l-live-list-item"
                            :class="{ 'l-live-list-user': item.current === 1 }">
                            <div class="l-live-list-item-box">
                                <div class="level"></div>
                                <div class="name">{{ item.userName }}</div>
                                <div class="status">
                                    <div class="status-icon" :class="{
                                        'leave':
                                            item.live === liveType.USER_LEAVE, 'absenteeism': item.live === liveType.USER_ABSENT
                                    }">
                                        {{ item.live }}</div>
                                </div>
                                <div class="add">

                                </div>
                                <div class="subtract">

                                </div>
                                <div class="award">
                                </div>
                            </div>
                            <img v-if="item.current === 1" class="l-live-list-one" src="./images/one.png" alt="">
                        </li>


                    </ul>
                </div>
                <div class="l-list-explain">
                    <div class="explain-title">直播指导总结</div>
                    <div class="explain-main" v-html="listData.liveSummary"></div>
                </div>
            </div>

        </div>
        <Lrule :isClose="isShowRule" @closeRule="handleShowRule"></Lrule>
        <LGetCurrency :opsions="currentData"></LGetCurrency>
    </div>
</template>
<script>
import Lrule from "./components/l-rule-description/index.vue"
import LGetCurrency from "./components/l-get-currency/index.vue"
import { liveType } from "./../constans/enum"
import TaskModel from './../models/task'
import UPModel from '@/models/imgup'
const taskModel = new TaskModel()
const upModel = new UPModel()

export default {
    name: 'liveDetail',
    components: {
        Lrule,
        LGetCurrency
    },
    data() {
        return {
            taskId: null,

            listData: {
                rankList: [],
                absenceList: []
            },
            liveType: liveType,
            currentData: {},
            isShowRule: false,
            userRank: null,//排名
        }
    },
    watch: {
        listData(newVal) {
            if (!newVal.storyUrl) return
            this.getFullUrl(newVal.storyUrl).then((res) => {
                this.listData.storyUrl = res.data[0]
            })
        }
    },
    mounted() {
        this.taskId = this.$route.params.taskId

        this.handleGetList()
    },
    methods: {
        handleGetList() {
            let params = {
                taskId: this.taskId
            }
            taskModel.getLiveRank(params).then(res => {
                const story = JSON.parse(res.data?.story??'{}')
                this.listData = {
                    ...res.data,
                    storyName: story.name,
                    storyUrl: story.url,
                }
                let currentList = [...this.listData.rankList, ...this.listData.absenceList]
                currentList.forEach((item) => {
                    if (item.current === 1) {
                        this.currentData = item
                        this.currentData.userRank = item.num
                    }
                })
                this.currentData.taskId = this.taskId
                this.currentData.singeRate = this.listData.singeRate
                // if (!this.currentData.showRead) {
                //     taskModel.postLiveRead({ taskId: this.taskId })
                // }
            })
        },

        handleGoBack() {
            this.$router.back()
        },
        handleShowRule() {
            this.isShowRule = !this.isShowRule
        },

        async getFullUrl(url) {
            return upModel.resource({
                paths: [url]
            })
        }
    }
}
</script>
<style scoped lang="stylus">
@import "./css/detail.styl";

.story-record-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 20px;
    margin: 12px -8px 0 -8px;
    background-color: #f9fdff;
    border-radius: 12px;
    // 添加内部灰色阴影
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
    color: #3e5a8e;
    font-size: 20px;
    font-weight: bold;
}
.record-header-label {
    min-width: 2.1rem;
    text-align: center;
}
.story-record {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 20px;
    background-color: #f6b248;
    border-radius: 12px;
    // 添加内部灰色阴影
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5);
}
.record-label {
    min-width: 2.1rem;
    text-align: center;
    color: #884629;
    font-size: 20px;
    font-weight: bold;
}
.record-audio {
    height: 52px;
}
</style>